// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var MM_provers = require("../mm-utils/MM_provers.res.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Belt_HashSetInt = require("rescript/lib/js/belt_HashSetInt.js");
var MM_parenCounter = require("../mm-utils/MM_parenCounter.res.js");
var MM_substitution = require("../mm-utils/MM_substitution.res.js");
var MM_wrk_ctx_data = require("./MM_wrk_ctx_data.res.js");
var MM_wrk_settings = require("./MM_wrk_settings.res.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");

function preCtxDataMake(settings) {
  return {
          settingsV: Common.versionMake(settings),
          srcs: [],
          ctxV: Common.versionMake({
                full: MM_context.createContext(undefined, undefined),
                min: MM_context.createContext(undefined, undefined)
              }),
          frms: MM_substitution.frmsEmpty(),
          parenCnt: MM_parenCounter.parenCntMake(0, 0, 0, 0, 0),
          allTypes: [],
          syntaxTypes: [],
          parensMap: Belt_HashMapString.make(0),
          typeOrderInDisj: Belt_HashMapInt.make(0),
          typeColors: Belt_HashMapString.make(0),
          symColors: Belt_HashMapString.make(0),
          asrtSyntaxTrees: undefined
        };
}

function findTypes(ctx) {
  var syntaxTypes = Belt_HashSetInt.make(16);
  var allTypes = Belt_HashSetInt.make(16);
  MM_context.forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
          var typ = hyp.expr[0];
          Belt_HashSetInt.add(allTypes, typ);
          if (hyp.typ === "F") {
            Belt_HashSetInt.add(syntaxTypes, typ);
          }
          
        }));
  MM_context.forEachFrame(ctx, (function (frame) {
          Belt_HashSetInt.add(allTypes, frame.asrt[0]);
          frame.hyps.forEach(function (hyp) {
                var typ = hyp.expr[0];
                Belt_HashSetInt.add(allTypes, typ);
                if (hyp.typ === "F") {
                  return Belt_HashSetInt.add(syntaxTypes, typ);
                }
                
              });
        }));
  return [
          Belt_HashSetInt.toArray(allTypes),
          Belt_HashSetInt.toArray(syntaxTypes)
        ];
}

function createSymbolColors(ctx, typeColors) {
  var symbolColors = Belt_HashMapString.make(100);
  MM_context.forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
          if (hyp.typ === "F") {
            var typeStr = MM_context.ctxIntToSym(ctx, hyp.expr[0]);
            if (typeStr !== undefined) {
              var color = Belt_HashMapString.get(typeColors, typeStr);
              if (color !== undefined) {
                Belt_HashMapString.set(symbolColors, MM_context.ctxIntToSymExn(ctx, hyp.expr[1]), color);
              }
              
            }
            
          }
          
        }));
  return symbolColors;
}

function preCtxDataUpdate(preCtxData, settings, ctx) {
  var settingsV = Core__Option.mapOr(settings, preCtxData.settingsV, (function (settings) {
          return Common.versionSet(preCtxData.settingsV, settings);
        }));
  var match = Core__Option.mapOr(ctx, [
        preCtxData.srcs,
        preCtxData.ctxV
      ], (function (param) {
          var ctx = param[1];
          return [
                  param[0],
                  Common.versionSet(preCtxData.ctxV, {
                        full: ctx,
                        min: ctx
                      })
                ];
        }));
  var ctxV = match[1];
  var ctxFull = MM_context.ctxOptimizeForProver(ctxV.val.full, settingsV.val.parens, false, false, true);
  var ctxMin = MM_context.ctxOptimizeForProver(ctxFull, settingsV.val.parens, true, true, false);
  var ctxV$1 = Common.versionSet(ctxV, {
        full: ctxFull,
        min: ctxMin
      });
  var ctxMin$1 = ctxV$1.val.min;
  var frms = MM_substitution.prepareFrmSubsData(ctxMin$1);
  var parenCnt = MM_provers.makeParenCnt(ctxMin$1, settingsV.val.parens);
  var match$1 = findTypes(ctxMin$1);
  var parenInts = MM_wrk_ctx_data.prepareParenInts(ctxMin$1, settingsV.val.parens);
  var numOfParens = parenInts.length / 2 | 0;
  var parensMap = Belt_HashMapString.make(numOfParens);
  for(var i = 0; i < numOfParens; ++i){
    Belt_HashMapString.set(parensMap, MM_context.ctxIntToSymExn(ctxMin$1, parenInts[(i << 1)]), MM_context.ctxIntToSymExn(ctxMin$1, parenInts[(i << 1) + 1 | 0]));
  }
  var typeOrderInDisj = Common.createTypeOrderFromStr(settingsV.val.sortDisjByType, (function (__x) {
          return MM_context.ctxSymToInt(ctxMin$1, __x);
        }));
  var typeColors = MM_wrk_settings.settingsGetTypeColors(settingsV.val);
  var symColors = createSymbolColors(ctxMin$1, typeColors);
  return {
          settingsV: settingsV,
          srcs: match[0],
          ctxV: ctxV$1,
          frms: frms,
          parenCnt: parenCnt,
          allTypes: match$1[0],
          syntaxTypes: match$1[1],
          parensMap: parensMap,
          typeOrderInDisj: typeOrderInDisj,
          typeColors: typeColors,
          symColors: symColors,
          asrtSyntaxTrees: undefined
        };
}

exports.preCtxDataMake = preCtxDataMake;
exports.preCtxDataUpdate = preCtxDataUpdate;
exports.findTypes = findTypes;
exports.createSymbolColors = createSymbolColors;
/* Common Not a pure module */
